import React from "react";
import "./services.css";
import BasicDemo from "../shared/galleria";

const ServicesSection = () => {
  const cart = [
    {
      title: "Various Adventures",
      description:
        "Explore a wide range of thrilling adventures — from mountain trekking and river rafting to desert safaris and cultural expeditions, designed for every type of traveler.",
      icon: "./images/icons/adven-home-new-icon-06.png",
    },
    {
      title: "Adventurous Trails",
      description:
        "Follow breathtaking trails through forests, mountains, and valleys. Each route is carefully curated for both beginners and experienced explorers.",
      icon: "./images/icons/adven-home-new-icon-05.png",
    },
    {
      title: "Trained Guides",
      description:
        "Travel with certified guides who ensure your safety and enrich your journey with deep local knowledge, fascinating stories, and insider tips.",
      icon: "./images/icons/adven-home-new-icon-04.png",
    },
    {
      title: "Family Trips",
      description:
        "Enjoy fun-filled adventures perfect for families — safe, educational, and exciting experiences that create lasting memories for all ages.",
      icon: "./images/icons/adven-home-new-icon-03.png",
    },
    {
      title: "Custom Packages",
      description:
        "Design your own adventure! Choose destinations, activities, and accommodations to create a personalized travel experience tailored to your interests.",
      icon: "./images/icons/adven-home-new-icon-02.png",
    },
    {
      title: "Complete Guide",
      description:
        "Get everything you need to plan your next trip — detailed itineraries, expert travel advice, and insider recommendations for a seamless adventure.",
      icon: "./images/icons/adven-home-new-icon-01.png",
    },
  ];

  return (
    <div className="services-container">
      <div className="middleContainer">
        <div className="middle-left">
          <h1>Why Choose Us</h1>
          <p>
            As a rapidly growing B2B tourism company, we focus on building
            strong partnerships and delivering value-driven solutions. We work
            tirelessly to provide our customers with reliable products and smart
            plans that help them thrive in the competitive travel market.
          </p>
          <ul className="middle-points">
            <li>Strong B2B Partnerships</li>
            <li>Global Reach and Local Expertise</li>
            <li>Innovative Travel Solutions</li>
            <li>Reliable and Transparent Service</li>
          </ul>
        </div>

        <div className="middle-right">
          <img src="/images/4.jpg" alt="Our Team" className="middle-image" />
        </div>
      </div>

      <div className="upContainer">
        <div className="services-header">
          <h1 style={{ fontWeight: "bold" }}>
            Our <span style={{ color: "#21a8b9" }}>Services</span>
          </h1>
          <p className="services-description">
            We offer a wide range of services to cater to your travel needs,
            including personalized travel planning, group tours, and 24/7
            customer support. Our team of experienced travel consultants is
            dedicated to ensuring that your travel experience is seamless and
            unforgettable. Whether you're looking for a relaxing beach vacation
            or an adventurous trek, we have the expertise to make it happen. Let
            us help you create memories that will last a lifetime.
          </p>
        </div>
        <div className="services-video">
          <video
            src="/videos/vds.mp4"
            autoPlay
            loop
            muted
            className="video-design"
          />
        </div>
      </div>
      <div className="downContainer">
        <div className="galleriedemo">
          <BasicDemo />
        </div>
        <div className="downContainer-header">
          <h1 style={{ fontWeight: "bold" }}>
            We are a fast growing <span style={{ color: "#21a8b9" }}>B2B</span>{" "}
            Tourism company
          </h1>
          <p className="services-description">
            We provide a wide range of B2B tourism services designed to support
            travel agencies and partners worldwide. With our expertise and
            strong global network, we make it easier for you to deliver the best
            experiences to your customers.
          </p>
          <ul className="description-list">
            <li>
              <b>Hotel Bookings :</b> Access thousands of hotels worldwide at
              competitive B2B rates.
            </li>
            <li>
              <b>Flight Reservations :</b> Fast and reliable ticketing solutions
              for every destination.
            </li>
            <li>
              <b>Customized Travel Packages :</b> Tailored tours and packages to
              fit your clients’ needs.
            </li>
            <li>
              <b>B2B Partnerships :</b> Exclusive deals and collaborations that
              help your business grow.
            </li>
            <li>
              <b>Business Growth Solutions :</b> Strategic support to maximize
              profitability and success.
            </li>
          </ul>
        </div>
      </div>
      <div className="endContainer">
        <div className="endContainer-overlay">
          <div className="endContainer-content">
            <div className="endContainer-header">
              <h3 className="value-text">Value before business</h3>
              <h1 className="offer-text">We Offer the best</h1>
            </div>
            <div className="endContainer-grid">
              {cart.map((item, index) => (
                <div className="end-item" key={index}>
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="service-icon"
                  />
                  <div>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
